import React from "react";
import { PrintStatus } from "./IReport";

interface StatusBadgeProps {
  status: PrintStatus;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const STATUS_CONFIG: Record<
    PrintStatus,
    { label: string; classes: string }
  > = {
    // 🔵 Approval statuses
    [PrintStatus.REQUESTED]: {
      label: "Requested",
      classes: "bg-yellow-100 text-yellow-700 border-yellow-200",
    },
    [PrintStatus.APPROVED]: {
      label: "Approved",
      classes: "bg-blue-100 text-blue-700 border-blue-200",
    },
    [PrintStatus.REJECTED]: {
      label: "Rejected",
      classes: "bg-red-100 text-red-700 border-red-200",
    },

    // 🔵 Printing statuses
    [PrintStatus.NOT_YET_STARTED]: {
      label: "Not Requested",
      classes: "bg-gray-100 text-gray-700 border-gray-200",
    },
    [PrintStatus.IN_PROGRESS]: {
      label: "In Progress",
      classes: "bg-purple-100 text-purple-700 border-purple-200",
    },
    [PrintStatus.COMPLETED]: {
      label: "Completed",
      classes: "bg-green-100 text-green-700 border-green-200",
    },
    [PrintStatus.FAILED]: {
      label: "Failed",
      classes: "bg-red-100 text-red-700 border-red-200",
    },
  };

  const config = STATUS_CONFIG[status];

  return (
    <span
      className={`px-2 py-1 rounded-full text-[12px] font-medium border ${config.classes}`}
    >
      {config.label}
    </span>
  );
};
